import { FormGroup, Input } from '@agro-club/agroclub-shared'
import { SizeType } from '@agro-club/agroclub-shared/dist/cjs/ui/form/FormGroup/DesktopFormGroup/DesktopFormGroup'
import { FormikErrors } from 'formik'
import { FormikFieldsType } from 'modules/domain/types'
import { FC, ReactNode } from 'react'

type Props = {
  error?: string | string[] | FormikErrors<any> | FormikErrors<any>[]
  formik: FormikFieldsType
  placeholder?: string
  disabled?: boolean
  required?: boolean
  label?: ReactNode
  field: string
  type?: string
  size?: 'thin' | 'small' | 'medium' | 'big'
  disableRightPadding?: boolean
  labelWidth?: number
  afterControlComponent?: ReactNode
}

const sizeMap: Record<string, SizeType> = {
  thin: 'small',
  small: 'small',
  medium: 'middle',
  big: 'large',
}

export const FormInput: FC<Props> = ({
  required = false,
  placeholder,
  disabled,
  formik,
  label,
  field,
  error,
  type,
  size,
  disableRightPadding,
  labelWidth,
  afterControlComponent,
}) => {
  return (
    <FormGroup
      label={label}
      error={error || formik.errors[field]}
      required={required}
      disableRightPadding={disableRightPadding}
      labelWidth={labelWidth}
      afterControlComponent={afterControlComponent}
      labelHeight={size ? sizeMap[size] : undefined}
    >
      <Input
        invalid={!!error || !!formik.errors[field]}
        {...formik.getFieldProps(field)}
        placeholder={placeholder}
        disabled={disabled}
        type={type}
        inputSize={size}
      />
    </FormGroup>
  )
}
